import { render, staticRenderFns } from "./PulseLoader.vue?vue&type=template&id=c63c0966&scoped=true"
import script from "./PulseLoader.vue?vue&type=script&lang=ts"
export * from "./PulseLoader.vue?vue&type=script&lang=ts"
import style0 from "./PulseLoader.vue?vue&type=style&index=0&id=c63c0966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63c0966",
  null
  
)

export default component.exports